const initializeFaq = () => {
  console.log('initializeFaq')


  document.querySelectorAll('.ms-faq-item').forEach(item => {
    item.addEventListener('click', () => {
      const icon = item.querySelector('.ms-icon')
      updateItem(item, !icon.classList.contains('open'))
    })
  })


  window.addEventListener('hashchange', hashChanged)
}


const hashChanged = () => {
  console.log(location.hash)
  if (location.hash && 0 < location.hash.length) {
    const item = document.querySelector(location.hash)
    if (item.classList.contains('ms-faq-item')) {
      updateItem(item, true)
    }
  }
}


const updateItem = (item, open) => {
  const icon = item.querySelector('.ms-icon')
  const text = item.querySelector('.ms-text')
  if (open) {
    icon.classList.add('open')
    item.style.maxHeight = (text.getBoundingClientRect().height + 72 + 24) + 'px'
  } else {
    icon.classList.remove('open')
    item.style.maxHeight = '72px'
  }
}


if (location.pathname == '/pages/faq') {
  document.addEventListener("DOMContentLoaded", _event => {
    initializeFaq()
  })
}
